// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","331":"b6a98aa4295515f9659675b765f8ccc6"}[chunkId] + ".js";
};